import React, { useEffect, useState } from "react";
import { CommonModal, Spinner } from "../../AbstractElements";
import { Row, Col, Form } from "reactstrap";
import { useForm, useController } from "react-hook-form";
import Select from "react-select";
import { blockDriver, getDriverBlockReasons } from "../../Services/Driver.service";
import { showAlert } from "../../Services/Shared.service";
import CustomSelect from "../../CommonElements/CustomSelect";

const BlockDriver = ({ Large, title, LargeModaltoggle, driverObj, fetchDriverData }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();
  const reasonField = useController({
    name: "reason",
    control,
    rules: {
      required: {
        value: true,
        message: "Reason is Required",
      },
    },
  }).field;
  const [reasonData, setReasonData] = useState([]);
  useEffect(() => {
    if (!Large) return;
    getDriverBlockReasons().then((result) => {
      if (result.data && result.data.length > 0) {
        const arr = result.data.map((element) => {
          return {
            label: element.reason,
            value: element,
          };
        });
        setReasonData(arr);
      }
    });
  }, [Large]);

  const handleReasonSelect = (option) => {
    reasonField.onChange(option.value);
  };

  const onBlockDriverSubmit = (formValues) => {
    setIsSubmitting(true)
    let obj = {
      reason: formValues.reason?.reason,
      driverId: driverObj.id.toString(),
    };
    blockDriver(obj).then(async (result) => {
      showAlert('success', "Driver blocked successfully")
      await fetchDriverData()
      await fetchDriverData()
      setIsSubmitting(false)
      reset()
      LargeModaltoggle();
    }).catch(err => {
      setIsSubmitting(false)
      showAlert('error', err.response?.data?.message
        ? err.response.data.message : 'Something went wrong')
    })
  };
  return (
    <CommonModal
      isOpen={Large}
      title={title}
      toggler={()=>{
        reset()
        LargeModaltoggle()
      }}
      size="md"
    >
      <Row className="driver-push-notification">
        <Form onSubmit={handleSubmit(onBlockDriverSubmit)}>
          <Col xl="12" className="push-botification-body">
            <div>
              Please provide a reason for blocking the driver :{" "}
              {driverObj.fullName}
            </div>
            <CustomSelect
              className="service-select"
              classNamePrefix="select"
              isClearable={false}
              isSearchable={false}
              // defaultValue={reasonData.find((element) => {
              //   return element?.value?.id === cityField?.value?.id;
              // })}
              onChange={handleReasonSelect}
              placeholder="Select Reason"
              options={reasonData}
            />
            <span style={{ color: "red" }}>{errors?.reason?.message}</span>
          </Col>
          <Col xl="12" className="push-notification-footer">
            {!isSubmitting ? (<button disabled={reasonField.value?.reason ? false : true} className="btn btn-primary" type="submit">
              Done
            </button>) :
              (<div className="loader-box" style={{ height: "50px" }}>
                <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
              </div>)}

          </Col>
        </Form>
      </Row>
    </CommonModal>
  );
};

export default BlockDriver;
